/**
* @file 资源管理-角色权限-创建角色
* */
<template>
  <div id="roleForm">
    <el-form :model="form" :rules="rules" ref="form" label-width="114px">
      <el-form-item label="角色名称" prop="roleName">
        <el-input style="width: 300px" v-model="form.roleName" maxlength="10"></el-input>
      </el-form-item>
      <el-form-item label="机构名称" prop="organizationId">
        <el-select style="width: 300px" :disabled="id ? true : false" v-model="form.organizationId" filterable
                   v-if="mixinUserInfo && mixinUserInfo.organizationType === 1" @change="getMenuList">
          <el-option v-for="(item, i) in organizations" :key="i" :value="item.id" :label="item.name">
          </el-option>
        </el-select>
        <span v-else>
          {{ organizations && organizations[0] && organizations[0].name }}</span>
      </el-form-item>
      <!--1-总公司，2分公司-->
      <el-form-item label="菜单权限" prop="menuIds" v-if="form.organizationId">


        <p class="util-remark">开启菜单权限后，角色下的账号就能看到这些菜单</p>


        <!--一级菜单 -->
        <div class="menu" v-for="(level1, i) in menuList" :key="i">
          <div class="main-menu">
            <el-checkbox size="mini" v-model="level1.check" :label="level1.menuName"
                         @change="checkFn(level1)"></el-checkbox>
          </div>
          <!--一级菜单下的按钮-->
          <div class="children-menu-btn" v-if="level1.buttons && level1.buttons.length > 0">
            <el-checkbox v-for="(level3, k) in level1.buttons" :key="k" :label="level3.name" v-model="level3.check"
                         @change="checkFn(level3, level1)"
            ></el-checkbox>
          </div>

          <!--二级菜单-->
          <div class="children-menu" v-if="level1.children && level1.children.length > 0">
            <div v-for="(level2, j) in level1.children" :key="j">
              <el-checkbox v-model="level2.check" :label="level2.menuName"
                           @change="checkFn(level2, level1)"></el-checkbox>
              <!--二级菜单下的按钮-->
              <div class="children-menu-btn" v-if="level2.buttons && level2.buttons.length > 0">
                <el-checkbox v-for="(level3, k) in level2.buttons" :key="k" v-model="level3.check" :label="level3.name"
                             @change="checkFn(level3, level2, level1)"></el-checkbox>
              </div>

              <!--三级菜单-->
              <div class="children-menu" v-if="level2.children && level2.children.length > 0">
                <div v-for="(level3, k) in level2.children" :key="k">
                  <el-checkbox v-model="level3.check" :label="level3.menuName"
                               @change="checkFn(level3, level2, level1)"></el-checkbox>

                  <!--三级菜单下的按钮-->
                  <div class="children-menu-btn" v-if="level3.buttons && level3.buttons.length > 0">
                    <el-checkbox v-for="(level4, k) in level3.buttons" :key="k" v-model="level4.check"
                                 :label="level4.name" @change="checkFn(level4, level3, level2, level1)"></el-checkbox>
                  </div>
                </div>
              </div>


            </div>
          </div>
        </div>


      </el-form-item>


      <el-form-item style="padding: 20px 0 50px">
        <el-button type="primary" @click="saveClick" :loading="loading">保存</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
export default {
  name: "roleForm",
  data() {
    return {
      // 司机id
      id: this.$route.query.id,
      // 表单
      form: {},
      // 校验规则
      rules: {
        roleName: [
          {required: true, message: "角色名称"},
          {pattern: /^.{2,10}$/, message: "请输入2-10位的名称"},
        ],
        organizationId: [{required: true, message: "请选择机构名称"}],
        menuIds: [
          {
            required: true,
            message: "请至少勾选一个选项",
            trigger: ["change"],
          },
        ],
      },
      // 保存按钮loading
      loading: false,
      // 菜单信息列表
      menuList: [],
      // 角色权限id数组
      permissions: [],
    };
  },

  async created() {
    await this.mixinOrganizations();
    await this.roleInfo();
    if (
        !this.id && this.mixinUserInfo?.organizationType === 2
    ) {
      if (
          this.organizations &&
          this.organizations[0]?.id
      ) {
        this.$set(this.form, "organizationId", this.organizations[0].id);
      }
    }


    const {type, organizationId} = this.$route.query
    if (type && organizationId) {
      this.$set(this.form, "organizationId", Number(organizationId));
    }
    await this.getMenuList();

    if (type === 'channel') {
      this.$set(this.form, "menuIds", [1, 93]);
      this.$set(this.form, "buttonIds", []);
      this.setRoleFn(this.form.menuIds || [], this.form.buttonIds || []);
    }

    if (type === 'organization') {
      this.$set(this.form, "menuIds", []);
      this.$set(this.form, "buttonIds", []);
      await this.getArrPush(this.menuList)
      this.setRoleFn(this.form.menuIds || [], this.form.buttonIds || []);
    }
  },

  methods: {
    getArrPush(list) {
      list.forEach((item) => {
        this.form.menuIds.push(item.id)
        if (item.buttons && item.buttons.length > 0) {
          item.buttons.forEach((item) => {
            this.form.buttonIds.push(item.id)
          })
        }
        if (item.children && item.children.length > 0) {
          this.getArrPush(item.children)
        }
      })
    },
    /* 接口调用-获取菜单信息列表 */
    async getMenuList(val) {
      if (val) {
        this.$set(this.form, "menuIds", []);
        this.$set(this.form, "buttonIds", []);
      }
      this.menuList = [];
      if (!this.form.organizationId) {
        return;
      }
      let url = "/api/v1/manage/menu/" + this.form.organizationId;
      let data = await this.$axios.get(url);
      if (data && data.code === 1) {
        this.menuList = data.data || [];
        this.setRoleFn(this.form.menuIds || [], this.form.buttonIds || []);


      }
    },

    /**
     * 选中事件
     * @param target 操作对象
     * @param parent 操作对象祖先集
     */
    checkFn(target, ...parent) {
      console.log(target, parent);
      if (target.check && parent) {
        // 勾选状态且父级存在
        parent.map((item) => item.check = target.check); // 上面几级状态变为勾选
      }

      if (target.children?.length > 0) {
        // 下一级状态同步变化
        target.children.map((item) => {
          if (!((this.form.type == 2 && item.isDisabled == 1) || (item.isDisabled == 1 && !this.id))) {
            // 以下权限禁用且不勾选
            item.check = target.check;
          }
          this.checkFn(item); // 下n级
        });
      }

      if (target.buttons?.length > 0) {
        // 下一级状态同步变化
        target.buttons.map((item) => {
          item.check = target.check;
        });
      }

      this.menuCodesFn();
    },

    /* 选中菜单id集合拼接成菜单权限id集合与按钮权限集合 */
    menuCodesFn() {
      let menuIds = [];
      let buttonIds = [];

      this.menuList.map((level1) => {
        if (level1.check) {
          menuIds.push(level1.id);
        }

        if (level1.children?.length > 0) {
          level1.children.map((level2) => {
            level2.check && (menuIds.push(level2.id));
            if (level2.buttons?.length > 0) {
              level2.buttons.map((level3) => {
                level3.check && (buttonIds.push(level3.id))
              });
            }

            if (level2.children?.length > 0) {
              level2.children.map((level3) => {
                level3.check && (menuIds.push(level3.id))
                if (level3.buttons?.length > 0) {
                  level3.buttons.map((level4) => {
                    level4.check && (buttonIds.push(level4.id))
                  });
                }
              });
            }
          });
        }

        if (level1.buttons?.length > 0) {
          console.log(level1.buttons);
          level1.buttons.map((level3) => {
            level3.check && (buttonIds.push(level3.id))
          });
        }
      });
      this.$set(this.form, "menuIds", menuIds);
      this.$set(this.form, "buttonIds", buttonIds);

      this.form = JSON.parse(JSON.stringify(this.form));
    },

    /* 点亮菜单 */
    setRoleFn(menuIds, btnIds) {

      let lightUp = (list, type) => {

        list.map(item => {
          if (type == 'menu') {
            if (menuIds.includes(item.id)) {
              this.$set(item, 'check', true)
            }
            if (item.children?.length) {
              lightUp(item.children, 'menu')
            }
            if (item.buttons?.length) {
              lightUp(item.buttons, 'button')
            }
          } else {
            if (btnIds.includes(item.id)) {
              this.$set(item, 'check', true)
            }
          }
        })

      }

      lightUp(this.menuList, 'menu');
    },

    /* 点击保存 */
    async saveClick() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.loading = true;
          let params = this.$utils.deepCopyFn(this.form);
          params.menuIds = params.menuIds ? params.menuIds.join(",") : "";
          params.buttonIds = params.buttonIds ? params.buttonIds.join(",") : "";
          if (this.id) {
            this.putFn(params);
          } else {
            this.postFn(params);
          }
        } else {
          this.$message.warning("请检查表单数据是否输入正确！");
          return false;
        }
      });
    },

    /* 接口请求-提交角色 */
    async postFn(params) {
      let url = "/api/v1/manage/role";
      let data = await this.$axios.post(url, params);
      if (data && data.code === 1) {
        this.$message.success("保存成功！");
        this.$router.go(-1);
      }
      this.loading = false;
    },

    /* 接口请求-修改角色 */
    async putFn(params) {
      let url = "/api/v1/manage/role";
      let data = await this.$axios.put(url, params);
      if (data && data.code === 1) {
        this.$message.success("保存成功！");
        this.$router.go(-1);
      }
      this.loading = false;
    },

    /* 获取权限详情 */
    async roleInfo() {
      if (this.id) {
        let url = "/api/v1/manage/role/" + this.id;
        let data = await this.$axios.get(url, { appKey: this.mixinUserInfo?.appKey });
        if (data && data.code === 1) {
          this.form = data.data || {};
        }
      }
    },
  }
};
</script>

<style lang="less">
#roleForm {
  .menu {
    border: 1px solid #f2f2f2;
    padding-left: 10px;

    .main-menu {
      height: 30px;
      line-height: 30px;
    }

    .children-menu {
      line-height: 30px;
      margin-left: 30px;

      .el-checkbox {
        margin: 0;
        margin-right: 30px;
      }
    }

    .children-menu-btn {
      line-height: 30px;
      margin-left: 30px;

      .el-checkbox {
        margin: 0;
        margin-right: 30px;
      }
    }
  }

  .menu + .menu {
    margin-top: 20px;
  }
}
</style>
